/**
 * This hook sends a tracking event to mixpanel when a user
 * uses esc key to close modal
 */
import { useCallback, useEffect } from 'react';

import MixpanelConfig from '../constants/mixpanelConfig';
import useAnalytics from './useAnalytics';

const useEscModalTrack = (
  modalSource: string,
  isOpen: boolean,
  resetThumbnailClickCount?: (number: number) => {}
) => {
  const track = useAnalytics();
  const handleKeyDown = useCallback(
    event => {
      // Used to reset the number of times any thumbnail has been clicked on multimedia overlay
      if (resetThumbnailClickCount) {
        resetThumbnailClickCount(0);
      }
      if (event.key === 'Escape') {
        track(MixpanelConfig.names.escCloseModal, {
          source: modalSource
        });
      }
    },
    [modalSource, resetThumbnailClickCount, track]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown, true);
    } else {
      document.removeEventListener('keydown', handleKeyDown, true);
    }

    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [isOpen, modalSource, handleKeyDown]);
};

export default useEscModalTrack;
